export default {
  title: {
    en: 'What is a card security code?',
  },
  text: {
    en: 'A three- or four-digit code on your credit card. The location varies slightly depending on your type of card',
  },
  backOfCard: {
    en: 'Back of card',
  },
  frontOfCard: {
    en: 'Front of card',
  },
}
